import { UpdateMsoAnnualActivityRefinerDraft, UpdateMsoAnnualActivityRefinerField } from "psims/models/submission-types/mso/annual-activity/refiner/update-mso-annual-activity-refiner";//importer/update-mso-annual-activity-importer
import { UpdateMsoStockholdingRefinerDraft } from "psims/models/submission-types/mso/annual-activity/refiner/update-mso-stockholding-refiner";//importer/update-mso-stockholding-import
import { MAX_VOLUME } from "./shared";

export type ValidationAlertResult = {
  key: UpdateMsoAnnualActivityRefinerField | 'totalAnnualVolume';
  code: 'MSOImportVolumeOnBehalfOutOfRange' | 'MSOImportVolumeByOthersOutOfRange' | 'MSOTotalImportVolumeNegative';
}

export function validationAlertsForRefinerAnnualActivity(annualActivity: UpdateMsoAnnualActivityRefinerDraft, totalAnnualVolume: number, imports: Array<UpdateMsoStockholdingRefinerDraft>): Array<ValidationAlertResult> {
  let messages: Array<ValidationAlertResult> = [];
   
  if (annualActivity.totalImportVolumeOnBehalf != null && annualActivity.totalImportVolumeOnBehalf > MAX_VOLUME) {
    messages.push({
      key: 'totalImportVolumeOnBehalf',
      code: 'MSOImportVolumeOnBehalfOutOfRange',
    });
  }

  if (annualActivity.totalImportVolumeOthers != null && annualActivity.totalImportVolumeOthers > MAX_VOLUME) {
    messages.push({
      key: 'totalImportVolumeOthers',
      code: 'MSOImportVolumeByOthersOutOfRange',
    });
  }

  //if (totalAnnualVolume < 0) {
 //   messages.push({
  //    key: 'totalAnnualVolume',
  //    code: 'MSOTotalImportVolumeNegative',
  //  })
  //}

  return messages;
}
